import { ReactElement, useMemo } from 'react';
import { PreviewToggleButtonStates } from '@dreryk/react-components/dist/PreviewToggleButton/PreviewToggleButton.types';

import { AppointmentUpdatePresenceConfirmedCommand } from '@dreryk/egabinet-appointment-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';
import { VisitAndAppointmentViewQuery } from '@dreryk/egabinet-visit-frontend-api';

import { PreviewToggleButton, ReservationApprovedIcon, ReservationNotApprovedIcon } from '@dreryk/react-components';
import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';

import { appointmentsTranslationKeys } from '../../../../translations';

const t = appointmentsTranslationKeys;

const usePreviewToggleButtonStates = (disabled: boolean): PreviewToggleButtonStates => {
   return useMemo(
      () => ({
         on: {
            icon: <ReservationApprovedIcon />,
            tooltipContent: disabled
               ? t.appointmentConfirmationStatusUpdateAvailableOnlyInPlannedStatus
               : t.markAppointmentConfirmationStatusAsNotConfirmed,
         },
         off: {
            icon: <ReservationNotApprovedIcon />,
            tooltipContent: disabled
               ? t.appointmentConfirmationStatusUpdateAvailableOnlyInPlannedStatus
               : t.markAppointmentConfirmationStatusAsConfirmed,
         },
      }),
      [disabled]
   );
};

type AppointmentConfirmationStatusProps = {
   confirmed: boolean;
   disabled: boolean;
   appointmentId: number;
};

export const AppointmentConfirmationStatus = (props: AppointmentConfirmationStatusProps): ReactElement => {
   const { executeAsync: updateAppointmentPresenceConfirmationStatus } = useCqrsCommand<void, unknown>(
      () => {
         const command = new AppointmentUpdatePresenceConfirmedCommand();
         command.presenceConfirmed = !props.confirmed;
         command.id = AppointmentId.of(props.appointmentId);
         return command;
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(VisitAndAppointmentViewQuery);
         },
      }
   );

   const previewToggleButtonStates = usePreviewToggleButtonStates(props.disabled);

   return (
      <PreviewToggleButton
         testId={'appointmentConfirmationStatus'}
         value={props.confirmed}
         states={previewToggleButtonStates}
         onClick={updateAppointmentPresenceConfirmationStatus}
         disabled={props.disabled}
      />
   );
};
